import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiBriefcase } = FiIcons;

const STATUS_OPTIONS = [
  { id: 'non-cadre', label: 'Non-cadre', rate: '22%' },
  { id: 'cadre', label: 'Cadre', rate: '25%' },
  { id: 'public', label: 'Public', rate: '15%' },
  { id: 'portage', label: 'Freelance', rate: '50%' },
];

export default function StatusSelector({ status, setStatus }) {
  return (
    <div>
      <div className="flex items-center gap-1.5 mb-3">
        <SafeIcon icon={FiBriefcase} className="text-indigo-400" />
        <h3 className="text-[11px] font-bold text-slate-500 uppercase tracking-tighter">Statut</h3>
      </div>
      <div className="grid grid-cols-4 gap-1">
        {STATUS_OPTIONS.map((opt) => (
          <button
            key={opt.id}
            onClick={() => setStatus(opt.id)}
            className={`flex flex-col items-center justify-center py-2 px-1 rounded-xl border text-center transition-all ${
              status === opt.id
                ? 'border-indigo-500 bg-indigo-50 ring-1 ring-indigo-500'
                : 'border-slate-100 bg-white hover:border-slate-200 hover:bg-slate-50'
            }`}
          >
            <span className={`text-[10px] font-bold leading-tight truncate w-full ${status === opt.id ? 'text-indigo-700' : 'text-slate-600'}`}>
              {opt.label}
            </span>
            <span className={`text-[9px] mt-0.5 font-medium ${status === opt.id ? 'text-indigo-500' : 'text-slate-400'}`}>
              {opt.rate}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}